module.exports = __webpack_public_path__ + "assets/img/tou.bcf68cae.jpg";